import React from 'react'
import { Route, Redirect, withRouter, Switch } from 'react-router-dom'
import { observer, inject } from 'mobx-react'

import { Loading } from '../../components'
import Confirm from './Confirm'
import Login from './Login'
import { ForceChangePassword, Register } from './'
import { ResetPassword1 } from './ResetPassword1'
import ResetPassword2 from './ResetPassword2'
import './Auth.css'
import MultiFactorLoginPage from './MultiFactorLoginPage'
import { ApolloWrapperAnon } from '../../App'

const debug = require('debug')('sd:Auth')

const RenderAuth = ({ auth }) => {
  if (auth.state === auth.states.resetPassword || auth.lastPreLoginAction === 'forgotPassword') return <ResetPassword2 />
  // To use this we need to improve the logic
  // if (auth.state === auth.states.confirming) return <Confirm />
  return (
    <Switch>
      <Route exact path='/register' name='Register' render={() => <ApolloWrapperAnon><Register /></ApolloWrapperAnon>} />
      <Route exact path='/registration' name='Register' render={() => <ApolloWrapperAnon><Register /></ApolloWrapperAnon>} />
      <Route path='/register/:source' name='Register' render={() => <ApolloWrapperAnon><Register /></ApolloWrapperAnon>} />
      <Route path='/registration/:source' name='Register' render={() => <ApolloWrapperAnon><Register /></ApolloWrapperAnon>} />
      <Route exact path='/confirm' name='Confirm' component={Confirm} />
      <Route exact path='/login' name='Login' component={Login} />
      <Route from='/login/:source' name='Login' component={Login} />
      <Route path='/auth/:source' name='Auth Channel Login' component={Login} />
      <Route path='/load/:source' name='Load Call Login' component={Login} />
      <Route exact path='/change-password-required' name='Change Password Required' component={ForceChangePassword} />
      <Route exact path='/reset-password' name='Reset Password' component={ResetPassword1} />
      <Route exact path='/mfa-code' name='Multi-Factor Auth' component={MultiFactorLoginPage} />
      <Route path='/'>
        <Redirect to='/login' />
      </Route>
    </Switch>
  )
}

export default inject('stores')(withRouter(observer(
  class Auth extends React.Component {
    render () {
      const { auth } = this.props.stores
      if (auth.state === auth.states.booting) return <Loading />
      return (
        <div className='auth'>
          <RenderAuth auth={auth} />
        </div>
      )
    }
  }
)))

debug('loaded')
